import { color, elevation, spaces } from "emoreg/const";
import { rem } from "polished";
import styled, { css, keyframes } from "styled-components";

import { ENTER_DURATION_MS } from "./constants";
import { TooltipPosition } from "./types";
import { computeEnterOffset } from "./utils";

export const TriggerContainer = styled.span`
  /* No margin on purpose: spacing around a tooltip belongs to whoever places it. */
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const buildEnterAnimation = (side: TooltipPosition) => keyframes`
  from {
    opacity: 0;
    transform: ${computeEnterOffset(side)};
  }
  to {
    opacity: 1;
    transform: none;
  }
`;

// Built once at module load rather than on every render of a bubble.
const ENTER_ANIMATIONS: Record<TooltipPosition, ReturnType<typeof keyframes>> = {
  top: buildEnterAnimation("top"),
  bottom: buildEnterAnimation("bottom"),
  left: buildEnterAnimation("left"),
  right: buildEnterAnimation("right"),
};

export const Bubble = styled.div<{ side: TooltipPosition; maxWidth?: number }>`
  padding: ${spaces[8]} ${spaces[12]};
  background: #fff;
  border-radius: 4px;
  box-shadow: ${elevation.high};
  width: max-content;
  font-size: ${rem(12)};
  line-height: 1.4;
  color: ${color.grey.darker};
  ${({ maxWidth }) =>
    maxWidth
      ? css`
          max-width: ${rem(maxWidth)};
          white-space: normal;
        `
      : css`
          white-space: nowrap;
        `}
  /* Show only: hiding unmounts the bubble. */
  animation: ${({ side }) => ENTER_ANIMATIONS[side]} ${ENTER_DURATION_MS}ms ease-out;
`;
